module.exports = __webpack_public_path__ + "img/slot_frame.28a59bc3.png";